import { generateMutations } from '../builder'

export default {
  ...generateMutations('getFormats', 'formats'),
  ...generateMutations('getFormat', 'format'),
}
